import Vue from 'vue';

if(document.getElementById('settings-organization')){

    $(document).ready(function() {

        var countrySelect = $("#organizationform-country_id");
        var citySelect = $("#organizationform-city_id");
        var orgSelect = $("#organizationform-org_id");

        countrySelect.select2({
            placeholder: "Введите страну",
            theme: 'select-city',
            allowClear: true,
            doReset:true
        });

        citySelect.select2({
            placeholder: "Введите город",
            theme: 'select-city',
            minimumInputLength: 1,
            allowClear: true,
            doReset:true,
            templateResult: function (data) {
                if (data.region) {
                    return data.text + ", " + data.region;
                }

                return data.text;
            },
            ajax: {
                url: "/data/city-list",
                data: function (params) {
                    var query = {
                        q: params.term,
                        country: settingsOrganization.country
                    };
                    return query;
                },

                cache: true
            }
        });

        orgSelect.select2({
            placeholder: "Введите название организации",
            theme: 'select-city',
            allowClear: true,
            minimumInputLength: 3,
            doReset:true,
            templateResult: function (data) {
                return data.text;
            },
            ajax: {
                url: "/data/org-list",
                data: function (params) {
                    var query = {
                        q: params.term,
                        country: settingsOrganization.country,
                        city: settingsOrganization.city,
                        addother:1
                    };
                    return query;
                },

                cache: true
            }
        });

        citySelect.on('change',function(e){

            if(settingsOrganization.org !== 'other'){
                settingsOrganization.org = null;
                orgSelect.empty();
            }

        });

        countrySelect.on('change',function(e){
            citySelect.empty();
            orgSelect.empty();
            settingsOrganization.city = null;
        });

        $(".search-sity").select2({
            theme: 'select-city',
            allowClear: true,
            doReset:true,
            doToggle:false,
            doOrder:false
        });


    });


    var settingsOrganization = new Vue({

        el:"#settings-organization",
        data:{
            org:orgId,
            org_region:null,
            city:cityId,
            country:countryId
        }

    })

}